import { render, staticRenderFns } from "./EditOrderItemBufferDate.vue?vue&type=template&id=118b8007"
import script from "./EditOrderItemBufferDate.vue?vue&type=script&lang=js"
export * from "./EditOrderItemBufferDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports